import ElementUI from "element-ui"
import variable from './variable'
// region 日期格式化
function timeFormat(time, fmt) {
    const o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        "S": time.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt || '1970-01-01 00:00:00'
}
Date.prototype.Format = function (fmt = 'yyyy-MM-dd hh:mm:ss') {
    return timeFormat(this, fmt)
}
Date.prototype.FormatShort = function () {
    return timeFormat(this, 'yyyy-MM-dd')
}
String.prototype.Format = function (fmt = 'yyyy-MM-dd hh:mm:ss') {
    if(isNaN(this) && !isNaN(Date.parse(this))){
        return timeFormat(new Date(this), fmt)
    }
}
String.prototype.FormatShort = function () {
    if(isNaN(this) && !isNaN(Date.parse(this))){
        return timeFormat(new Date(this), 'yyyy-MM-dd')
    }
}
// endregion

// 深拷贝
const clone = (obj) => {
    let o
    if (typeof obj === 'object') {
        if (obj === null) {
            o = null;
        } else {
            if (obj instanceof Array) {
                o = [];
                for (let i = 0, len = obj.length; i < len; i++) {
                    o.push(clone(obj[i]));
                }
            } else if (obj instanceof Date) {
                o = new Date(obj)
            } else {
                o = {};
                for (let j in obj) {
                    o[j] = clone(obj[j]);
                }
            }
        }
    } else {
        o = obj;
    }
    return o;
}

// loading的变量
let targetLoading = {};

function joinObj() {
    const obj = {}
    for (let i = 0; i < arguments.length; i++) {
        Object.assign(obj, arguments[i])
    }
    return obj
}

const store = {
    get(key) {
        const value = localStorage.getItem(key)
        if (value) {
            try {
                const value_json = JSON.parse(value)
                if (typeof value_json === 'object') {
                    return value_json
                } else if (typeof value_json === 'number') {
                    return value_json
                }
            } catch(e) {
                return value
            }
        } else {
            return false
        }
    },
    set(key, value) {
        localStorage.setItem(key, value)
    },
    remove(key) {
        localStorage.removeItem(key)
    },
}

export default {
    tokenHelp: {
        get() {
            return store.get('tokenBM')
        },
        set(token) {
            store.set('tokenBM', token);
        },
        remove() {
            store.remove('tokenBM')
        },
    },

    // 深拷贝
    deepClone: clone,

    // 合并参数
    joinObj,

    // 翻页通用参数
    getPage(obj) {
        return Object.assign({
            current: 1,
            size: 20,
            total: 0,
        }, obj)
    },

    arrToStr(list, field) {
        return list.map(item => item[field]);
    },

    loading(message = '加载中...') {
        targetLoading = ElementUI.Loading.service({
            lock: true,
            target: 'body',
            text: message,
            background: '#0000004d',
        });
    },
    loaded() {
        targetLoading.close && targetLoading.close();
    },

    success(msg) {
        ElementUI.Message({
            type: 'success',
            showClose: true,
            message: msg
        });
    },
    info(msg) {
        ElementUI.Message({
            showClose: true,
            message: msg
        });
    },
    error(msg) {
        ElementUI.Message({
            type: 'error',
            showClose: true,
            message: msg
        });
    },
    // storage操作
    store: store,

    isSelect(type) {
        return [variable.colType.SELECT, variable.colType.DATE].includes(type)
    },

    // vue 往parent寻找，如果找到了方法，就执行
    execFuncByParent($vue, func, data) {
        $vue.$parent.$parent.$parent.$parent.$parent.$parent[func](data)
    },


    renderLine(el, list) {
        const myChart = window.echarts.init(document.getElementById(el))
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            toolbox: {
                feature: {
                    dataView: {show: true, readOnly: false},
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                }
            },
            legend: {
                data: list.map(item => item.name)
            },
            xAxis: [
                {
                    type: 'category',
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    axisPointer: {
                        type: 'shadow'
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    splitLine: {     //网格线
                        show: false
                    }
                },
                {
                    type: 'value',
                    splitLine: {     //网格线
                        show: false
                    }
                }
            ],
            series: list.map(item => {
                if (item.type === 'line') {
                    item.yAxisIndex = 1
                }
                return item
            })
        }

        myChart.setOption(option)
    },

    renderChina (el, data, handle) {
        data.sort(function(o1, o2) {
            if (isNaN(o1.value) || o1.value == null) return -1;
            if (isNaN(o2.value) || o2.value == null) return 1;
            return o1.value - o2.value;
        });

        var option = {
            // title: {
            //     text: title,
            //     x: 'center'
            // },
            backgroundColor: '#0F1C3C',
            tooltip: {
                show: true,
                formatter: function(params) {
                    if (params.data) {
                        return `${params.name}<br>总纯销金额:${params.data.source.amount}<br>品规数:${params.data.source.invNum}<br>人口:${params.data.source.personNum}`
                    }
                    return ''
                },
            },
            visualMap: {
                type: 'continuous',
                text: ['', ''],
                showLabel: true,
                seriesIndex: [0],
                min: 0,
                max: 1,
                inRange: {
                    color: ['#061E3D','#34cbef']
                },
                textStyle: {
                    color: '#000'
                },
                bottom: 30,
                left: 'left',
                show: false,
            },
            geo: {
                // roam: 'move',
                map: 'china',
                show: true,
                roam: false,
                layoutSize: '100%',
                label: {
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        borderColor: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#00F6FF'
                        }, {
                            offset: 1,
                            color: '#53D9FF'
                        }], false),
                        borderWidth: 3,
                        shadowColor: 'rgba(10,76,139,1)',
                        shadowOffsetY: 0,
                        shadowBlur: 60
                    }
                }
            },
            series: [
                {
                    type: 'map',
                    map: 'china',
                    aspectScale: 0.75,
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: true,
                            textStyle:{
                                color: 'white'

                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#073684' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#061E3D' // 100% 处的颜色
                                }],
                            },
                            borderColor: '#215495',
                            borderWidth: 1,
                        },
                        emphasis: {
                            areaColor: {

                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#073684' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#061E3D' // 100% 处的颜色
                                }],
                            },
                        }
                    },
                    data: data
                },

            ]
        };
        const myChart = window.echarts.init(document.getElementById(el));
        if (handle) {
            myChart.off('click')
            myChart.on('click', function (param) {
                handle(param)
            })
        }
        myChart.setOption(option)
    },

    renderArea(el ,list) {
        const myChart = window.echarts.init(document.getElementById(el))
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    show: false
                }
            },
            xAxis: {
                type: 'category',
                data: list.map(item => item.name),
                axisLine: {
                    lineStyle: {
                        color: ['#e9e9e9', '#fff'],
                    }
                },
                axisTick: {
                    show: false
                },
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: '#e9e9e9'
                    }
                },
                axisTick: {
                    show: false
                },
            },
            series: [{
                data: list.map(item => item.value),
                type: 'bar',
                barWidth: 15,
                itemStyle: {
                    normal: {
                        barBorderRadius:[5, 5, 0, 0],
                        color: '#58c2f3'
                    }
                },

                label: {
                    show: true,
                    precision: 1,
                    position: 'top',
                    valueAnimation: true,
                    fontFamily: 'monospace'
                }
            }]
        }

        myChart.setOption(option)
    }
}

